export const PortalClienteResource = 'Reclamacion';

export const Role = {
  acceso: { action: 'acceso' },
  misReclamaciones: { action: 'misReclamaciones' },
  verReclamacion: { action: 'verReclamacion' },
  altaReclamacion: { action: 'altaReclamacion' },
  desistirReclamacion: { action: 'desistirReclamacion' },
  añadirPagoParcial: { action: 'añadirPagoParcial' },
  suspensiónCautelarReclamacion: { action: 'suspensiónCautelarReclamacion' },
  marcarRecuperadaReclamacion: { action: 'marcarRecuperadaReclamacion' },
  miCuenta: { action: 'miCuenta' },
  misFacturas: { action: 'misFacturas' },
  consultaFichero: { action: 'consultaFichero' },
  misConsultas: { action: 'misConsultas' },
  clienteMayorista: { action: 'clienteMayorista' },
  editarCliente: { action: 'editarCliente' },
  editarUsuario: { action: 'editarUsuario' }
}
